import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
    {
        field: 'truck_number',
        headerName: 'truck_number',
        flex: 1,
        minWidth: 150,
        editable: false
    }, 
    {
        field: 'tracking_number',
        headerName: 'tracking_number',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
    {
        field: 'date',
        headerName: 'date',
        flex: 1,
        minWidth: 100,
        valueGetter: (params) => {
            if(!params.row.date) return "";
            return params.row.date.substring(0, 10);
        }, 
        editable: false
    },
];

function OnTruckTable(props) {

    return(
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"}>
            <Box className = {props.isMobile ? "mobile-table-box" : "desktop-table-box"}>
                <DataGrid
                    className = {props.isMobile ? "mobile-table" : "desktop-table"}
                    sx = {{ 
                        width: '75%',
                        height: "1000px",
                        '& .red-row': {
                            backgroundColor: '#FAA0A0', 
                            '&:hover': {
                                backgroundColor: '#cc3333',  
                            },
                        },
                    }}
                    rows = {props.packages}
                    getRowId = {(row) => row.id}
                    columns = {columns}
                    rowsPerPageOptions = {[25, 50, 100]}
                    checkboxSelection = {false}
                />
            </Box>
        </Box>
    )

}

export default OnTruckTable;